import { Button, Checkbox, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutImagingServices extends Layout {
    checkboxAutoRefresh: Checkbox;
    checkboxLock: Checkbox;
    host: Textbox;
    listServices: Button;
    panelButtons: Panel;
    port: Textbox;
    restartAll: Button;
    startAll: Button;
    startService: Button;
    stopAll: Button;
    stopService: Button;
    tableServices: Table;
    txtCount: Textbox;
}
